import React, { PropTypes } from 'react'
// import mode from 'containers/mode'
import Heading from 'components/Heading'
import Card from 'components/Card'
// import IconLogoDaeCircle from 'icons/jpg/DAEPubCircle.jpg'
import { IconArticle, IconVideo, IconHeadphone } from 'icons'
import styles from './Tile.scss'

// const styles = Object.assign({},
//   require('../../../styles.scss'),
//   require('./Tile.scss'),
// )

const Tile = ({
  id, imageUrl, newsDate, title, mediaType, description, openNewsDialog,
}) => {
  // const mediaIcon = mediaType === 'article' ? <IconArticle height="18" width="18"/> : (mediaType === 'audio' ? <IconHeadphone height="18" width="18"/> : <IconVideo height="18" width="18"/>)

  // const actionLabel = mediaType === 'article' ? 'READ INSIGHT' : (mediaType === 'audio' ? 'GO TO PODCAST' : 'WATCH')

  return (
    <Card noPadding className={styles.base}>
      <div className={styles.content}>
        <div className={styles.top}>
          {imageUrl ? <img alt="" className={styles.customerImg} src={imageUrl} /> :
          <img alt="" src={`${process.env.PUBLIC_URL}/images/home_personal_info1.png`} />}
        </div>

        <div className={styles.bottom}>
          <div>{title}</div>
          <div className={styles.stats}>
            <div className={styles.description} >{description}</div>
            {/* <Heading noPadding className={styles.title}>{title}</Heading>
            <div className={styles.footer}>
              <div className={styles.duration}>{mediaIcon}&nbsp;&nbsp;<div>{duration}</div></div>
              <div>
                <a className={styles.callToAction} onClick={() => { openNewsDialog(id) }}>{actionLabel}</a>
              </div>
            </div> */}
          </div>

        </div>
        <div className={styles.separater} />
      </div>
    </Card>
  )
}

Tile.propTypes = {
  id: PropTypes.string,
  imageUrl: PropTypes.string,
  newsDate: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  actionLabel: PropTypes.string,
  openNewsDialog: PropTypes.func,
}

export default Tile



// WEBPACK FOOTER //
// ./src/views/Home/components/Tile/Tile.js